// ASAYIT Theme JS

// ── CART DRAWER ──
const cartOverlay = document.getElementById('cart-overlay');
const cartDrawer = document.getElementById('cart-drawer');

function openCart() {
  cartOverlay?.classList.add('open');
  cartDrawer?.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  cartOverlay?.classList.remove('open');
  cartDrawer?.classList.remove('open');
  document.body.style.overflow = '';
}

document.getElementById('cart-btn')?.addEventListener('click', openCart);
document.getElementById('cart-close')?.addEventListener('click', closeCart);
cartOverlay?.addEventListener('click', closeCart);

// ── SIZE SELECTOR ──
document.querySelectorAll('.size-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('.size-selector__options')
      .querySelectorAll('.size-btn')
      .forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    const variantId = btn.dataset.variantId;
    const addBtn = document.getElementById('add-to-cart-btn');
    if (addBtn) {
      addBtn.dataset.variantId = variantId;
      addBtn.disabled = false;
    }
  });
});

// ── ADD TO CART ──
document.getElementById('add-to-cart-btn')?.addEventListener('click', async function() {
  const variantId = this.dataset.variantId;
  if (!variantId) {
    // Flash size selector
    document.querySelector('.size-selector__label').style.color = 'red';
    setTimeout(() => {
      document.querySelector('.size-selector__label').style.color = '';
    }, 800);
    return;
  }

  this.textContent = 'ADDING...';
  this.disabled = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (res.ok) {
      await updateCartDrawer();
      openCart();
    }
  } catch(e) {
    console.error(e);
  }

  this.textContent = 'ADD TO CART';
  this.disabled = false;
});

// ── UPDATE CART DRAWER ──
async function updateCartDrawer() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    // Update count
    const countEl = document.querySelector('.navbar__cart-count');
    if (countEl) countEl.textContent = cart.item_count > 0 ? `(${cart.item_count})` : '';

    // Update items
    const itemsEl = document.getElementById('cart-items');
    const subtotalEl = document.getElementById('cart-subtotal');

    if (itemsEl) {
      if (cart.items.length === 0) {
        itemsEl.innerHTML = '<p class="cart-empty">YOUR CART IS EMPTY</p>';
      } else {
        itemsEl.innerHTML = cart.items.map(item => `
          <div class="cart-item">
            <img class="cart-item__image" src="${item.image}" alt="${item.title}">
            <div class="cart-item__details">
              <p class="cart-item__name">${item.product_title}</p>
              <p class="cart-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
              <p class="cart-item__price">$${(item.final_price / 100).toFixed(2)}</p>
              <button class="cart-item__remove" data-key="${item.key}" onclick="removeItem('${item.key}')">REMOVE</button>
            </div>
          </div>
        `).join('');
      }
    }
    if (subtotalEl) {
      subtotalEl.textContent = `$${(cart.total_price / 100).toFixed(2)}`;
    }
  } catch(e) {
    console.error(e);
  }
}

async function removeItem(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  await updateCartDrawer();
}

// Load cart on page load
updateCartDrawer();
